// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { unitOfMeasureSelectStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsUnitOfMeasureSelect";
import { css } from "styled-components";

unitOfMeasureSelectStyles.unitOfMeasureSelect = {
    labelProps: {
        css: css`
            display: none;
        `,
    },
    sizeVariant: "small",
    cssOverrides: {
        formField: css`
            margin-top: 0;
            max-width: 140px;
        `,
        inputSelect: css`
            padding: 0 10px !important;
        `,
    },
};
